import { toast } from "react-toastify";
import { useMutation } from "react-query";
import { User, UserType } from "@ecologi/shared";
import { useStore } from "../../store";
import { APIError } from "../api";
import { formatAPIErrorForView } from "../selectors";

export const useUserMutation = (
  apiFn: (args: any[]) => Promise<UserType>,
  successMessage: string
) => {
  const { setUser } = useStore();

  return useMutation(apiFn, {
    onSuccess: (data) => {
      setUser(new User(data));
      toast.success(successMessage);
    },
    onError: (error: APIError) => {
      toast.error(formatAPIErrorForView(error));
    },
  });
};
